import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export interface PurchasedDataset {
  datasetId: string;
  purchasedAt: Date;
  version?: string;
  metadata?: {
    name?: string;
    category?: string;
    numImages?: number;
    numLabels?: number;
  };
}

export type PurchasedDatasetsMap = Record<string, PurchasedDataset>;

export function usePurchasedDatasets(uid?: string | null) {
  const [datasets, setDatasets] = useState<PurchasedDatasetsMap>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!uid) {
      setDatasets({});
      setLoading(false);
      return;
    }

    setLoading(true);
    const ref = collection(db, 'users', uid, 'purchasedDatasets');

    const unsubscribe = onSnapshot(
      ref,
      (snapshot) => {
        const map: PurchasedDatasetsMap = {};
        snapshot.forEach((doc) => {
          const data = doc.data();
          map[doc.id] = {
            datasetId: doc.id,
            purchasedAt: data.purchasedAt?.toDate?.() || new Date(),
            version: data.version,
            metadata: data.metadata || {},
          };
        });
        setDatasets(map);
        setLoading(false);
        setError(null);
      },
      (err) => {
        console.error('Failed to load purchased datasets', err);
        setDatasets({});
        setLoading(false);
        setError('Failed to load purchased datasets');
      }
    );

    return unsubscribe;
  }, [uid]);

  return { datasets, loading, error };
}








